/* VitaBase — animaciones de aparición y barra de compra fija */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt__title');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-mt-sticky]');
    if (!bar) return;
    var final = document.querySelector('[data-mt-final]');
    var finalVisible = false;
    if (final && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }).observe(final);
    }
    function update() {
      var show = window.scrollY > 700 && !finalVisible;
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initCarousels(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;
    (root || document).querySelectorAll('[data-mt-carousel]').forEach(function (c) {
      if (c.dataset.mtReady) return;
      c.dataset.mtReady = '1';
      var track = c.querySelector('[data-mt-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var interval = parseInt(c.dataset.interval || '4500', 10);
      var autoplay = c.dataset.autoplay === 'true' && !reduce && !designMode;
      var paused = false;
      var visible = false;
      var timer = null;
      var bar = c.querySelector('[data-mt-progress]');
      c.style.setProperty('--mt-interval', interval + 'ms');

      function slideWidth() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function go(dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior: 'smooth' });
        else track.scrollBy({ left: dir * slideWidth(), behavior: 'smooth' });
      }
      function restartBar() {
        if (!bar) return;
        bar.classList.remove('is-running');
        void bar.offsetWidth;
        if (autoplay && !paused && visible) bar.classList.add('is-running');
      }
      function schedule() {
        clearTimeout(timer);
        if (!autoplay || paused || !visible) return;
        timer = setTimeout(function () { go(1); schedule(); }, interval);
        restartBar();
      }
      function setPaused(p) {
        paused = p;
        c.classList.toggle('is-paused', p);
        if (p) { clearTimeout(timer); if (bar) bar.classList.remove('is-running'); }
        else schedule();
      }
      function markVisible() {
        var tr = track.getBoundingClientRect();
        slides.forEach(function (s) {
          var r = s.getBoundingClientRect();
          var inView = r.left >= tr.left - 4 && r.right <= tr.right + 4;
          s.classList.toggle('is-in', inView);
        });
      }

      var prev = c.querySelector('[data-mt-prev]');
      var next = c.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); schedule(); });
      if (next) next.addEventListener('click', function () { go(1); schedule(); });
      c.addEventListener('mouseenter', function () { setPaused(true); });
      c.addEventListener('mouseleave', function () { setPaused(false); });
      c.addEventListener('focusin', function () { setPaused(true); });
      c.addEventListener('focusout', function () { setPaused(false); });
      track.addEventListener('touchstart', function () {
        setPaused(true);
        clearTimeout(c._mtResume);
        c._mtResume = setTimeout(function () { setPaused(false); }, 6000);
      }, { passive: true });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; markVisible(); });
      }, { passive: true });
      window.addEventListener('resize', markVisible);
      markVisible();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) schedule(); else { clearTimeout(timer); if (bar) bar.classList.remove('is-running'); }
        }, { threshold: 0.3 }).observe(c);
      } else {
        visible = true;
        schedule();
      }
    });
  }

  // Cierra el selector de idiomas al pulsar fuera o con Escape
  function initLangSwitcher() {
    if (window.mtLangReady) return;
    window.mtLangReady = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-mt-lang][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-mt-lang][open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
  }

  function init() {
    initReveal();
    initStickyBar();
    initCarousels();
    initLangSwitcher();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initStickyBar();
    initCarousels(e.target);
  });
})();
